import {useContext, useEffect, useState} from 'react'
import {Row, Form, Button} from 'react-bootstrap'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import { ColaboradorObservacionContext } from '../../components/ColaboradorObservacionContexts'
import { ListDocuments } from './ListDocuments'


const KitDocumentoModalForm = () => {
  const {idProceso} = useContext(ColaboradorObservacionContext)

  return (
    <>
      <Form >
        <Row className='mb-3'>
            <ListDocuments id={idProceso} />
        </Row>
      </Form>
    </>
  )
}

export {KitDocumentoModalForm}
